/** @deprecated use DrawerV2 instead */
export enum DrawerComponentType {
  ConversationDetails = 'ConversationDetails',
  JobDescriptionHtml = 'JobDescriptionHtml',
  CampaignCreationJobDescriptionHtmlDrawer = 'CampaignCreationJobDescriptionHtmlDrawer',
  CandidateReport = 'CandidateReport',
  CandidateStatusDrawer = 'CandidateStatusDrawer',
  InviteUserDrawer = 'InviteUserDrawer',
  TeamPermissionsDrawer = 'TeamPermissionsDrawer',
  WhatsAppSetup = 'WhatsAppSetup',
  UpdateApplicationStage = 'UpdateApplicationStage',
  CalendarBookingDetailsDrawer = 'CalendarBookingDetailsDrawer',
  AnalysisRequirementsDrawer = 'AnalysisRequirementsDrawer',
  AnalysisRulesDrawer = 'AnalysisRulesDrawer',
  AnalysisActionsDrawer = 'AnalysisActionsDrawer',
  CandidateRankingGroupEdit = 'CandidateRankingGroupEdit',
  WhatsAppLearnMoreDrawer = 'WhatsAppLearnMoreDrawer',
  SMSLearnMoreDrawer = 'SMSLearnMoreDrawer',
  RulesetDrawer = 'RulesetDrawer',
  TemplateCreationDrawer = 'TemplateCreationDrawer',
  GlobalContextDrawer = 'GlobalContextDrawer'
}
